// 按页面划分
export default {
    // 公共页面
    common: {
        title: "ផ្សារទិន្នន័យ",
        pull_refresh: "ទាញចុះក្រោមដើម្បីធ្វើឱ្យស្រស់",
        release_refresh: "ដោះលែងឱ្យធ្វើឱ្យស្រស់",
        refresh_loading: "កំពុងផ្ទុក...",
        footer_text: "សេវាកម្មត្រូវបានផ្តល់ដោយ Ucloudlink (NASDAQ: UCL)"
    },
    home: {
        input_placeholder: "ស្វែងរកប្រទេស / តំបន់",
        my_flow: "ទិន្នន័យរបស់ខ្ញុំ",
        charge_code: "លេខកូដប័ណ្ណ",
        coupons: "បង្គត់កោ",
        local_package: "ទិន្នន័យក្នុងស្រុក",
        more: "រេចីនចាង",
        popular_destination: "ប្រទេស / តំបន់",
        buy_now: "ទិញឥឡូវ",
        package_useing: "សកម្ម",
        unused: 'មិនសកម្ម',
        download_app: "ទាញយកកម្មវិធី",
        enter_the_mall_list: "ចូលទៅកាន់បញ្ជីផ្សារ",
        no_data: "គ្មានទិន្នន័យ",
        no_data_available: 'គ្មានទិន្នន័យទេ',
        copy_success: "ចម្លងបានជោគជ័យ",
        copy_fail: "ចម្លងបរាជ័យ",
        meritsTitle: 'អត្ថប្រយោជន៍ជាអ្វី？',
        merits1: 'មិនចាំបាច់ប្រើ SIM & មិនមានថ្លៃខែ',
        merits2: 'រួមបញ្ចូលជាមួយប្រតិបត្តិករកំពូល 2-3 សម្រាប់ការប្តូរបណ្តាញដោយស្វ័យប្រវត្តិ។',
        go_buy: 'ទៅទិញ',
        instant_savings: 'សន្សំ',
        expires_in: 'ផុតពេលក្នុង',
        download_app_tips: "ទាញយកកម្មវិធីសម្រាប់ការផ្តល់ជូន និងបទពិសោធន៍បន្ថែម"
    },
    packages: {
        sub_title: {
            us: "ដោយមិនរាប់បញ្ចូលកោះ Guam, Saipan",
            it: "រួមទាំងទីក្រុងវ៉ាទីកង់, សាន់ម៉ារីណូ",
            va: "រួមទាំងអ៊ីតាលីសានម៉ារីណូ",
            sm: "រួមទាំងអ៊ីតាលី, ទីក្រុងវ៉ាទីកង់",
            ma: "រួមទាំងលោកសាហារ៉ាខាងលិច",
            eh: "រួមទាំងម៉ារ៉ុក",
            ch: "រួមទាំង liechtenstein",
            li: "រួមទាំងប្រទេសស្វីស",
            fr: "រួមទាំងម៉ូណាកូ",
            mc: "រួមទាំងបារាំង",
            fi: "រួមទាំងកោះអាឡែន",
            ax: "រួមទាំងហ្វាំងឡង់",
            gu: "រួមទាំងកោះម៉ារៀណាខាងជើង",
            mp: "រួមទាំងកោះ Guam"
        },
        unlimited_packages: "កញ្ចប់ទិន្នន័យគ្មានដែនកំណត់",
        normal_packages: "កញ្ចប់ទិន្នន័យធម្មតា",
        multi_region_packages: "ពហុតំបន់",
        regional_data: "ទិន្នន័យតំបន់",
        high_speed_text: "ទិន្នន័យល្បឿនលឿន",
        infiniteFlow: "ទិន្នន័យគ្មានដែនកំណត់",
        unLimitData: "គ្មានដែនកំណត់",
        high_speed_text_year: "ល្បឿនលឿន / MP",
        package_list: "បញ្ជីកញ្ចប់",
        special_offer: 'ការប្រពន្ធ',
        first_month: 'ខែទីមួយ',
        periodUnit: {
            day: "ថ្ងៃ",
            month: "ខេ",
            hour: "ម៉ោង",
            year: "ឈ្នាម"
        },
        periodUnits: {
            day: "ថ្ងៃ",
            month: "នៃរេប្យនៈ",
            hour: "ម៉ោង",
            year: "ច្រើនកើតមាន"
        },
        periodUnitSimp: {
            day: "ឃ",
            month: "សរមាប់",
            hour: "ច",
            year: "នេះ"
        },
        periodUnitMonthly:'រាល់ខែ',
        periodUnitsSimp: {
            day: "ឃ",
            month: "សរមាប់",
            hour: "ច",
            year: "នេះ"
        },
        unlimited_good_name: {
            day: "ឆ្លងកាត់ថ្ងៃ",
            month: "លិខិតឆ្លងដែនប្រចាំខែ",
            year: "ឆ្លងកាត់ប្រចាំឆ្នាំ"
        },
        continuousMonth: "សរមាប់",
        continuousDay: "សរមាប់",
        continuousYear: "នេះ",
        day_invalid: "ផុតកំណត់នៅថ្ងៃបច្ចុប្បន្ន",
        month_invalid: "ផុតកំណត់ក្នុងខែបច្ចុប្បន្ន",
        immediate_valid: "មានប្រសិទ្ធភាពភ្លាមៗ",
        tomorrow_day_valid: "មានប្រសិទ្ធិភាពចាប់ពីថ្ងៃបន្ទាប់",
        tomorrow_month_valid: "មានប្រសិទ្ធិភាពចាប់ពីខែបន្ទាប់",
        detail: {
            cell_flow: "តិន្នន័យ",
            cell_period: "សុបលផាប",
            buy_quantity: "ចមនយន",
            use_area: "សេវាបរិបេទើប",
            use_intro: "ល័ក្ខខ័ណ្ឌ",
            buy_btn: "ការដឹកនាម",
            pay: "ទូទាត់",
            buy_tips: 'អ្នកកំពុងប្រើប្រាស់ប៉ាកเก็จ %@packageName ហើយ តើអ្នកចង់ទិញប៉ាកเก็จនេះទេ？',
            haveOrderTips: "បានបង្កើតបញ្ជាទិញរង់ចាំទូទាត់។ ចុចបញ្ជាក់ដើម្បីទៅទំព័រទិន្នន័យរបស់ខ្ញុំ！"
        },
        confirm: {
            title: "ការបញ្ជាក់ការបញ្ជាទិញ",
            real_pay_amount: "ចំនួនទឹកប្រាក់ដែលបានបង់",
            online_payment: "ការទូទាត់តាមអ៊ីនធឺណិត",
            create_order_error: "ការរៀបចំបានបរាជ័យ"
        }
    },
    pay: {
        result: {
            loading_order_status: "ទទួលបានស្ថានភាពបញ្ជាទិញ ...",
            buy_success: "បញ្ជាទិញបានបញ្ចប់",
            buy_pending: "ការបញ្ចប់ការបញ្ជាក់",
            buy_pending_tip: "ការទូទាត់នៅក្នុងដំណើរការ ... ប្រសិនបើការទូទាត់មិនបានផ្ទេរក្នុងរយៈពេល 10 នាទីសូមព្យាយាមម្តងទៀត",
            get_payment_info_fail: "ការទិញយកព័ត៌មានការទូទាត់បានបរាជ័យ",
            cell_package: "កហ្ចប់",
            cell_buy_amount: "បុកសរុប",
            cell_real_amount: "ចំនួនទឹកប្រាក់ដែលបានបង់",
            go_to_order_btn: "ចូលទៅកញ្ចប់របស់ខ្ញុំ",
            back_home: "ត្រលប់ទៅផ្ទះ",
            back_mall: "ត្រលប់ទៅផ្សារ",
            ordersn_empty: "ការបញ្ជាទិញ SN មិនអាចទទេបានទេ",
            order_search_error: "កំហុសដែលមិនបានរំពឹងទុក",
            goodsName:'ឈ្មោះផលិតផល'
        },
        fail: {
            payment_fail: "ការទូទាត់បានបរាជ័យ",
            back_home: "ត្រលប់ទៅផ្ទះ"
        }
    },
    CountryGroup: {
        title: "ប្រទេស / តំបន់",
        placeholder: "ស្វែងរកប្រទេសឬតំបន់",
        clear: "ផ្លឺ",
        history: "ប្រវត្តិស្វែងរក"
    },
    PromotionCode: {
        verification: {
            title: "លេខកូដប័ណ្ណ",
            minititle: "លេខកូដបញ្ចូលគ្នា",
            input: "សូមបញ្ចូលលេខកូដបញ្ចូលទឹកប្រាក់",
            explain: "ព័ត៌មានជំនួយ: ប៉ះប៊ូតុងស្កេននៅខាងស្តាំខាងលើដើម្បីស្កេនលេខកូដ QR នៃកាតប័ណ្ណទូទាត់ឬបញ្ចូលកូដប័ណ្ណដោយដៃ (ប្រកាន់អក្សរតូចធំ) ប្រសិនបើវាមិនដំណើរការ។",
            submit: "ដាក់រេកាមបង្គាប់",
            exchange: "លមផុត",
            cancel: "លប់ចោល",
            Inquiry: "តើអ្នកប្រាកដទេថាបានផ្លាស់ប្តូរ",
            ErrorCode: "កំហុសបញ្ចូលលេខកូដបញ្ចូលគ្នា",
        },
        recharge_success: {
            package: "កហ្ចប់",
            content: "បានលោះដោយជោគជ័យ",
            back: "ត្រឡប់ទៅផ្សារទំនើប",
            view_packets: "ចូលទៅកញ្ចប់របស់ខ្ញុំ"
        }
    },
    order: {
        state: {
            inUse: "ធេវីសកម្ម",
            isFirst: "អាធិការ",
            toFirst: "កំណត់អាទិភាព",
            inactive: "អសកម្ម"
        },
        periodUnits: {
            minute: "នាទី)",
            hour: "ម៉ោង",
            day: "ថ្ងៃ",
            month: "ខែ (ស)"
        },
        useIntro: {
            tip1: "កញ្ចប់ទិន្នន័យគ្មានដែនកំណត់មានអាទិភាពខ្ពស់ជាងកញ្ចប់ទិន្នន័យបរិមាណ។",
            tip2: "អាទិភាពនៃការប្រើប្រាស់នឹងផ្អែកលើកាលបរិច្ឆេទទិញសម្រាប់ប្រភេទកញ្ចប់ដូចគ្នា។ អាទិភាពគឺសម្រាប់កញ្ចប់តែមួយ ទូទាត់ត្រឹមត្រូវ។",
            tip3: "អ្នកក៏អាចកែអាទិភាពនៃការប្រើប្រាស់កញ្ចប់ដែលមានប្រភេទដូចគ្នាបានដែរ។"
        },
        myFlow: "ទិន្នន័យរបស់ខ្ញុំ",
        remainingFlow: "ទិន្នន័យនៅសល់",
        remainingTime: "ខាងឆ្វេងត្រឹមត្រូវ",
        remainingHighFlow: "ទិន្នន័យល្បឿនលឿននៅសល់",
        validPeriod: "សុបលផាប",
        noneFlow: "គ្មានកញ្ចប់ទិន្នន័យទេ",
        noneFlowTip: "សូមទិញកញ្ចប់ទិន្នន័យហើយរីករាយនឹងបណ្តាញដែលមានគុណភាពខ្ពស់",
        buyPackFlow: "ទិញកញ្ចប់",
        checkInvalidFlow: "ពិនិត្យកញ្ចប់ទិន្នន័យដែលផុតកំណត់",
        orderList: {
          "title": "ការបញ្ជាទិញរបស់ខ្ញុំ",
          "amount_paid": "បុកសរុប",
          "device": "ឧបករណ៍ដែលគ្រប់គ្រង",
          "order_details": "ព័ត៌មានលម្អិតបញ្ជាទិញ",
          "total_amont": "និយាយ",
          "orderSN": "បញ្ជាទិញទេ។",
          "createTime": "ពេលវេលាបង្កើត",
          "cancelTime": "ពេលវេលាបិទ",
          "payTime": "ពេលវេលាបញ្ជាទិញ",
          "unsubTime": "បានបោះបង់ពេលវេលា",
          "payMethod": "វិធីសាស្ត្រទូទាត់",
          "thirdSN": "ប្រតិបត្តិការទេ",
          "delete": "របៅបេលរសច",
          "cancel": "បោះបង់ការបញ្ជាទិញ",
          "unsub": "ការសងរបាក់វិញ",
          "goto_cancel": "តើអ្នកចង់បោះបង់ការបញ្ជាទិញទេ?",
          "goto_unsubscribe": "តើអ្នកចង់ឈប់វែកញែកទេ?",
          "delete_Tips": "ការបញ្ជាទិញមិនអាចត្រូវបានបន្តបន្ទាប់ពីត្រូវបានលុបដូច្នេះបញ្ហាដែលអ្នកបានដោះស្រាយរបស់អ្នកមិនអាចដោះស្រាយបានទេ។តើអ្នកប្រាកដជាលុបវាចោលឬ?",
          "status_success": "បានបញ្ចប់",
          "status_pending": "ដេលក្ផានបង់ថ្លៃ",
          "status_cancel": "ដេលបិត",
          "status_unsub": "លប់លានផាក",
          "payMethod_stripe": "កាតឥណទាន"
        },
    },
    registerlogin: { 
        create_account_tip:"បង្កើតគណនីចាប់ផ្តើមបទពិសោធន៍ផ្តាច់មុខ។",
        select_country_tip:"ការប្រើប្រាស់ឧបករណ៍ប្រទេស / តំបន់",
        email_name: "ប្រៃសណីយ៍",
        phone_name: "ទូរសព្ទ៍",
        email_address: "អាសយដ្ឋានអ៊ីមែល",
        password: "ពាក្យសម្ងាត់",
        country: "ប្រទេស",
        select_country: "ជ្រើសរើសប្រទេសមួយ",
        cancel: "លប់ចោល",
        confirm: "បហ្ជាក់",
        please_enter: "សូមបញ្ចូលលេខ 6-20 (ការបញ្ចូលអក្សរលេខឬនិមិត្តសញ្ញា)",
        select_country_tips: "ការជ្រើសរើសប្រទេសគឺសម្រាប់ការមើលកញ្ចប់ក្នុងស្រុក។ វាមិនអាចផ្លាស់ប្តូរបានទេបន្ទាប់ពីការចុះឈ្មោះ។ សូមបញ្ជាក់!",
        global_roaming: "លេខកូដដែនអន្តរជាតិ",
        phone_number: "លេខទូរសព្ទ៍",
        agree: "យល់របម",
        user_agreement: "កិច្ចព្រមព្រៀងអ្នកប្រើប្រាស់",
        and: "និង",
        privacy_policy: "គោលការណ៍ភាពឯកជន",
        register_login: "ចុះឈ្មោះឬចូល",
        login_error: "ចំនួនឡូហ្គោគឺលឿនពេកហើយសូមព្យាយាមម្តងទៀតនៅពេលក្រោយ!",
        register_error: "ចំនួននៃការចុះឈ្មោះគឺញឹកញាប់ណាស់សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ!",
        forgot_pwd: "ភ្លេចពាក្យសម្ងាត់",
        app_tips: "ចូលទៅកម្មវិធីជាមួយគណនីនេះបន្ទាប់ពីទាញយកវាដើម្បីទទួលបានមុខងារបន្ថែម។",
        download_app: "ចូលទៅកាន់ទាញយកកម្មវិធី",
        rememberPwd: "ចងចាំពាក្យសម្ងាត់",
        third_login: "បន្តជាមួយ",
        agreement_tips: "សូមពិនិត្យមើលកិច្ចព្រមព្រៀងអ្នកប្រើប្រាស់និងប្រអប់គោលការណ៍ឯកជនភាព",
        selectCountry_tips: "សូមកត់សម្គាល់ថាប្រទេសដែលបានចុះបញ្ជីនឹងជះឥទ្ធិពលដោយផ្ទាល់ដល់វិធីសាស្រ្តទូទាត់និងរូបិយប័ណ្ណខាងក្រោមដោយផ្ទាល់សូមជ្រើសរើសដោយយោងតាមតម្រូវការរបស់អ្នក។",
        login_error_cancel: "អ្នកប្រើប្រាស់បានបោះបង់ការចូលគណនី",
        login_error_auth: "សូមអនុញ្ញាតប៉ុបអាប់ពីការកំណត់កម្មវិធីរុករក",
        device_tips: "ឧបករណ៍រង់ការធ្វើឱ្យសកម្ម។ ដំណើរការក្នុងរយៈពេល ២៤ ម៉ោង។"
      },
      forgotPwd: {
        forgot_pwd: "ភ្លេចពាក្យសម្ងាត់",
        email_address: "អាសយដ្ឋានអ៊ីមែល",
        next: "បន្ទាប់បិនេហ",
        email_has_been_sent: "យើងបានផ្ញើអ៊ីមែលទៅ %@email ។ សូមចុចលើតំណ ហើយធ្វើតាមជំហានដើម្បីទាញយកពាក្យសម្ងាត់របស់អ្នក។",
        have_retrieved_it: "ខ្ញុំបានរកឃើញវាហើយ",
        unable_to_receive_email: "មិនអាចទទួលអ៊ីមែលបានទេ? សូមពិនិត្យមើលថាតើមានអ៊ីមែលពី %@email នៅក្រោមសារឥតបានការរបស់អ្នក និងថតសំបុត្រដែលបានលុបឬអត់",
        or: "រឺ",
        resend: "ផ្ញើសារឡើងវិញ",
        global_roaming: "លេខកូដដែនអន្តរជាតិ",
        phone_number: "លេខទូរសព្ទ៍",
        verification_code_has_been_sent: "យើងបានផ្ញើលេខកូដផ្ទៀងផ្ទាត់ទៅ:",
        verification_code: "លេខកូដផ្ទៀងផ្ទាត់",
        no_verification_code_received: "មិនបានទទួលលេខកូដផ្ទៀងផ្ទាត់ទេ?",
        please_enter: "សូមបញ្ចូលលេខ 6-20 (ការបញ្ចូលអក្សរលេខឬនិមិត្តសញ្ញា)",
        reset_password: "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        reset_successful: "កំណត់ឡើងវិញដោយជោគជ័យ"
      },
      coupons: {
        coupons_name: "បង្គត់កោ",
        no_coupons: "មិនទាន់មានប័ណ្ណនៅឡើយទេ",
        no_data: "មិនទាន់មានទិន្នន័យនៅឡើយទេ",
        applicable_to_the_following: "គូប៉ុងគឺសមរម្យសម្រាប់កញ្ចប់ទិន្នន័យខាងក្រោម"
      },
      digital:{
        title:"ឧបករណ៍ sn",
        purchased:"ការទិញរបស់ខ្ញុំ",
        viewAll:"រេចីនចាង",
        skinStore:"ហាងលក់ផលិតផល",
        completed:"ទិញ",
        goBuy:"តិញ",
        order: {
          title:"ការបញ្ជាទិញដែលបានទិញ"
        },
        detail: {
          describe:"ការបិបន៍នា"
        }
      },
      viewPL: {
        other: 'ផ្សេងៗ'
      },
      invalidFlow: {
        stateName: "ច្បាប់",
        state: {
          NOT_ACTIVATED: "អសកម្ម",
          IN_USING: "មានរបយោចន៍",
          USE_END: "ដេលអស់កម្លាមង",
          EXPIRE: "ផុតសុក",
          TRANSFER: "ផ្ទេរ",
          UNSUBSCRIBE: "លប់ចោល",
          VALID: "បានការ",
          INVALID: "តុបល",
          EXCHANGE_POINTS: "ទទួលយកពិន្ទុ"
        },
        noneFlow: "មិនមានកញ្ចប់ទិន្នន័យផុតកំណត់ទេ",
        pageName: "កញ្ចប់ទិន្នន័យផុតកំណត់"
      },
      flowDetail: {
        title: "ព័ត៌មានលម្អិតអំពីទិន្នន័យ",
        flow: "តិន្នន័យ",
        validTime: "ការចាប់ផ្តើមត្រឹមត្រូវ",
        invalidTime: "មានសុពលភាពរហូតដល់",
        coverage: "សេវាបរិបេទើប",
        useIntro: "ល័ក្ខខ័ណ្ឌ",
        purchaseTime: "ទិញនៅ",
        subtotal: "បុកសរុប",
        status: "ច្បាប់",
        cancel: "លប់ចោល",
        buyAgain: "ទិញវាម្តងទៀត",
        validity: "សុបលផាប",
        tip: "ការសង្កេត",
        cancelTip: "តើអ្នកពិតជាចង់សងប្រាក់កញ្ចប់នេះមែនទេ?",
        dataLeft: "ទិន្នន័យនៅសល់"
      },
      netError: {
        try_again: "ព្យាយាមម្តងទៀត",
        net_error: "គ្មានបណ្តាញ",
        try_again_desc: "សូមពិនិត្យមើលការកំណត់បណ្តាញហើយព្យាយាមម្តងទៀត"
      },
      loadFail: {
        try_again: "ព្យាយាមម្តងទៀត",
        load_fail: "ការផ្ទុកបានបរាជ័យ",
        load_fail_desc: "ការផ្ទុកទិន្នន័យបានបរាជ័យសូមព្យាយាមម្តងទៀត",
        IMEI_Not_Exist: "អ៊ីមមិនមានទេសូមព្យាយាមចូលពីច្រកចូលខាងស្តាំ",
        Project_Not_Exist: "កំហុសកើតឡើង។ សូមទាក់ទងសេវាកម្មអតិថិជន។ (01)",
        commonError: "កំហុសកើតឡើង។ សូមទាក់ទងសេវាកម្មអតិថិជន។"
      },
      settlement_Easy_and_convenient: "ងាយស្រួលនិងងាយស្រួល",
      settlement_Great_deal: "អនាម័យ",
      settlement_Safe_and_secure: "មានសុវត្ថិភាពនិងសុវត្ថិភាព",
      settlement_Autopay_service_regulation: "បទប្បញ្ញត្តិនៃសេវាកម្មបង់ប្រាក់ដោយស្វ័យប្រវត្តិ",
      settlement_Read: "អាន",
      settlement_No_coupon: "មិនមានគូប៉ុងដែលមានទេ",
      settlement_Subtotal: "បុកសរុប",
      settlement_Coupon: "បង្គរ",
      settlement_TOTAL: "បុកសរុប",
      settlement_promotion_tip: "ការផ្តល់ជូនការផ្សព្វផ្សាយមិនអាចត្រូវបានប្រើក្នុងការភ្ជាប់ជាមួយគូប៉ុងណាមួយឡើយ",
      settlement_coupon_tip: "ប័ណ្ណនេះមិនអាចត្រូវបានប្រើរួមគ្នាជាមួយនឹងការផ្តល់ជូនពិសេសណាមួយផ្សេងទៀតឡើយ",
      member_myFlow_noList: "គ្មានទិន្នន័យ",
      detail_se_content: "អ្នកអាចឈប់ជាវនៅពេលណាមួយ",
      Enter_Promo_code: "លេខកូដផ្សព្វផ្សាយ",
      Enter_Promo_Coupon: "បង្គត់កោ",
      settlement_Not_used_coupon: "គូប៉ុងមិនត្រូវបានប្រើទេ",
      settlement_Available_coupon: "មានរបយោចន៍",
      settlement_Unavailable_coupon: "មិនមាន",
      please_Enter_Promo_code: "សូមបញ្ចូលលេខកូដផ្សព្វផ្សាយ",
      please_Select_Coupon_use: "សូមជ្រើសរើសគូប៉ុងដែលអ្នកចង់ប្រើ។",
      Buy_Now: "ទិញឥឡូវ",
      Dont_Use_Any: "កុំប្រើណាមួយ",
      settlement_confirm: "បហ្ជាក់",
      settlement_tips: "បហ្ជាក់",
      flowDetail_unsubscribe: "ឈប់ជាវ",
      flowDetail_unsubscribed: "មិនបានចុះឈ្មោះ",
      flowDetail_isCancelPackage: "ឈប់ជាវកញ្ចប់នេះទេ?",
      flowDetail_confirmAgreementUnsubscribe: "អ្នកមិនអាចមានកិច្ចព្រមព្រៀងដ៏អស្ចារ្យបន្ទាប់ពីឈប់ជាវ។ តើអ្នកពិតជាចង់ឈប់ជាវមែនទេ?",
      flowDetail_cancel: "លប់ចោល",
      flowDetail_cancelSuccess: "ឈប់ជាវដោយជោគជ័យ",
      packages_detail_promotion: "ការផសបវផសាយ",
      orderTips:{
        "iDay" : "ថៃ",
        "iDays" : "ថៃ",
        "iMonth" : "ខេ",
        "iMonths" : "នៃរេប្យនៈ",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol នៅលើការទិញដំបូងរបស់អ្នក, បង់ %@money/%@periodSymbol នៅពេលក្រោយ, អ្នកអាចឈប់ជាវនៅពេលណាមួយ",
        'Monthly_discount':"រក្សាទុក %@saveMoney នីមួយៗ %@period! អ្នកអាចឈប់ជាវនៅពេលណាមួយ",
        'Ordinary_monthly_package':"មធ្យោបាយសុវត្ថិភាពងាយស្រួលនិងងាយស្រួល។ អ្នកអាចឈប់ជាវនៅពេលណាមួយ",
        "AlreadyPurchased":'សូមអភ័យទោសដែលអ្នកអាចភ្ជាប់គម្រោងតែកញ្ចប់ទិន្នន័យមួយនៅពេលនេះបានទេ។ សូមឈប់ជាវពី “%@” ហើយចុះឈ្មោះជាវនៅពេលក្រោយទៅកញ្ចប់ណាមួយដែលអ្នកចង់បានបន្ទាប់ពីវាផុតកំណត់។',
        "Contract_recommendation_First":'<label>ជាមួយនឹងសេវាកម្មស្វ័យប្រវត្តិនៅពេលទិញដំបូងរបស់អ្នក, បង់ប្រាក់តែប៉ុណ្ណោះ</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">អ្នកអាចឈប់ជាវនៅពេលណាមួយ'
        +'<a class="btn">ជាវ ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>ជាមួយនឹងសេវាកម្មស្វ័យប្រវត្តិ, បង់តែប៉ុណ្ណោះ</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">អ្នកអាចឈប់ជាវនៅពេលណាមួយ'
        +'<a class="btn">ជាវ ></a></p>',
        "Contract_recommendation_General":"<label>ជាមួយនឹងសេវាកម្មស្វ័យប្រវត្តិ</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">មធ្យោបាយសុវត្ថិភាពងាយស្រួលនិងងាយស្រួល។ អ្នកអាចឈប់ជាវនៅពេលណាមួយ'
        +'<a href="javascript:;" class="btn">ជាវ ></a></p>',
        'BanlanceDoubleCheck':'តើអ្នកពិតជាចង់បង់ប្រាក់ដោយមានតុល្យភាពមែនទេ?',
    },
    feedback: {
      title: "មតិកែលម្អ",
      placeholder: "សូមចូលទៅកាន់ប្រទេសដែលអ្នកចង់ទស្សនាឬសំណួរផ្សេងទៀតហើយយើងនឹងបំពេញតម្រូវការរបស់អ្នកឱ្យបានឆាប់បំផុត!",
      submit: "ដាក់ស្នើ",
      submit_success: "ដាក់ស្នើដោយជោគជ័យ",
      other_opinions: "គំនិតផ្សេងទៀត"
    },
    view_country_input: 'សូមបញ្ចូលគណនីរបស់អ្នក',
    "select_package": {
      "title": "ជ្រើសរើសទិន្នន័យ",
      "allPackage": "ទិន្នន័យទាំងអស់",
      "type": "ប្រភេទ",
      "flow": "ទិន្នន័យ",
      "month_package": "ផែនការអស់ខែ",
      "flow_package": "កញ្ចប់ទិន្នន័យ",
      "time": "រយៈពេល",
      "period": "វដ្ត",
      "auto_debit": "ព័ត៌មានដកប្រាក់ស្វ័យប្រវត្តិ",
      "auto_subscribe": "្វ័យប្រវត្តិបន្ត",
      "detail": "ព័ត៌មានលម្អិតទិន្នន័យ",
      "carrier": "ព្រហសិតក្រុមហ៊ុនប្រតិបត្តិករ",
      "country": "ប្រទេសដែលគ្របដណ្តប់",
      "notice": "គู่มือការទិញ"
    }
}